import { createElement, $ } from '../../utils/dom';
import { getTyrisIcon } from '../ui/tyris-icon';

export type ToastType = 'success' | 'error' | 'info';

class ToastManager {
  private container: HTMLElement | null = null;

  private getContainer(): HTMLElement {
    if (this.container) return this.container;

    let el = $('#toast-container');
    if (!el) {
      el = createElement('div', {
        id: 'toast-container',
        className: 'toast-container',
      });
      document.body.appendChild(el);
    }
    this.container = el;
    return el;
  }

  show(message: string, type: ToastType = 'info', duration = 4000): void {
    const container = this.getContainer();
    
    // Iconos temáticos Tyris
    let icon = getTyrisIcon('consejo', { size: 20 });
    if (type === 'success') icon = getTyrisIcon('éxito', { size: 20 });
    if (type === 'error') icon = getTyrisIcon('error', { size: 20 });

    const toast = createElement('div', {
      className: `toast toast-${type}`,
    });

    toast.innerHTML = `
      <div style="display:flex;align-items:center;">${icon}</div>
      <div class="toast-content">${message}</div>
      <button class="toast-close" type="button">&times;</button>
    `;

    // Vincular cierre manual
    const closeBtn = toast.querySelector('.toast-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.dismiss(toast));
    }

    container.appendChild(toast);

    // Auto-cierre
    if (duration > 0) {
      setTimeout(() => this.dismiss(toast), duration);
    }
  }

  success(message: string, duration?: number): void {
    this.show(message, 'success', duration);
  }

  error(message: string, duration?: number): void {
    this.show(message, 'error', duration);
  }

  info(message: string, duration?: number): void {
    this.show(message, 'info', duration);
  }

  private dismiss(toast: HTMLElement): void {
    toast.style.animation = 'toastSlideIn 0.3s ease-in reverse forwards';
    toast.style.opacity = '0';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
      // Limpiar contenedor si no hay toasts
      if (this.container && this.container.children.length === 0) {
        this.container.parentNode?.removeChild(this.container);
        this.container = null;
      }
    }, 300);
  }
}

export const toast = new ToastManager();
